import { combineReducers } from 'redux';

import user from './user';
import payments from './payments';

export default combineReducers({
  ...user,
  ...payments,
});
